import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgBackIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M7.4 2.4 1 12l6.4 9.6" stroke="#007AFF" />
  </svg>
);
const Memo = memo(SvgBackIcon);
export default Memo;
